/**
 * Build a "display name" resolver for a set of calendar events. If two
 * employees in the set share a first name (e.g. two Geoffreys), both fall
 * back to "Firstname L." so the rendered tile / row disambiguates them.
 * Single-occurrence first names stay short.
 *
 * Pass the full list of events you're about to render (a month, an upcoming
 * list, etc.) so the collision check is scoped to what the user actually sees.
 */
export function buildDisplayNameFor(events) {
  const variants = new Map();
  for (const e of events) {
    const full = (e.employee_full_name || '').trim();
    if (!full) continue;
    const first = full.split(/\s+/)[0];
    if (!variants.has(first)) variants.set(first, new Set());
    variants.get(first).add(full);
  }
  return (fullName) => {
    const full = (fullName || '').trim();
    if (!full) return '';
    const parts = full.split(/\s+/);
    const first = parts[0];
    const collisions = variants.get(first);
    if (collisions && collisions.size > 1 && parts.length > 1) {
      return `${first} ${parts[1][0]}.`;
    }
    return first;
  };
}
